/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-date/webhook-form-date.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
  pointer-events: all;
}
/*# sourceMappingURL=webhook-form-date.component.css.map */
